import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalInterceptor } from './global.interceptor';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    {
     provide: HTTP_INTERCEPTORS,
     useClass: GlobalInterceptor,
     multi: true,
    }
  ]
})
export class InterceptadorModule { }
